import { IEditItem, EditItem } from "./editItem";

export interface IEditItemLockable extends IEditItem {
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;

    isLockedToUser(userCode: string): boolean;
    isLockedToOtherUser(userCode: string): boolean;
}

export class EditItemLockable extends EditItem implements IEditItemLockable {
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;

    constructor();
    constructor(obj: IEditItemLockable);
    constructor(obj?: any) {
        super(obj);
        this.lockedDate = obj && obj.lockedDate || null;
        this.lockedUserCode = obj && obj.lockedUserCode || "";
        this.lockedUserName = obj && obj.lockedUserName || "";
        this.lockedUserPicture = obj && obj.lockedUserPicture || "";
    }

    isLockedToUser(userCode: string): boolean {
        return !!this.lockedDate && !!this.lockedUserCode && userCode.equalIgnoreCase(this.lockedUserCode);
    }

    isLockedToOtherUser(userCode: string): boolean {
        return !!this.lockedDate && !!this.lockedUserCode && !userCode.equalIgnoreCase(this.lockedUserCode);
    }
}